export default __webpack_public_path__ + "static/tt-norms-medium-cda678279963f4ff1c034553eddb0de6.woff";